import { createFileRoute } from '@tanstack/react-router'
import { JobsSettings } from '@/features/settings/jobs-settings'

export const Route = createFileRoute('/_layout/_app/settings/jobs')({
  validateSearch: (search: Record<string, unknown>) => ({
    highlight: typeof search.highlight === 'string' ? search.highlight : undefined,
  }),
  component: JobsSettings,
})
